import React from 'react';
import KnowledgeBaseView from './KnowledgeBase';

function Recipes() {
    return <KnowledgeBaseView isRecipe={true} />;
}

export default Recipes;
